<template>

  <div class="user">
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <el-form-item label="是否开启分销" prop="is_coupon">
        <el-switch v-model="form.status"></el-switch>
      </el-form-item>

      <!-- <el-form-item label="通用直推类型：">
      <el-radio-group  v-model="form.ztype">
          <el-radio :label="0">固定</el-radio>
          <el-radio :label="1">比例</el-radio>
        </el-radio-group>

        </el-form-item>


        <el-form-item label="通用直推奖励：">
          <el-input v-model="form.zprice" type="number" :min="0" :max="100" :step="1"
           placeholder="请输入数额" class="max-w460">
            <template slot="append" v-if="form.ztype == 0" >元</template>
            <template slot="append" v-if="form.ztype == 1" >%</template>
          </el-input>
          <div v-if="form.ztype == 0">如固定{{form.zprice}}，直推A每单消费，奖励推荐者{{form.zprice}}元</div>
          <div  v-if="form.ztype == 1">如比例{{form.zprice}}%，直推A每单消费1000，奖励推荐者{{getPrice((form.zprice/100 ) * 1000 )}}元</div>
        </el-form-item> -->

      
        <el-form-item size="small" label="" >
        <div class="common-level-rail"><el-button size="small" icon="el-icon-plus" @click="addClick">添加商品</el-button></div>
        <div class="pb50">
          <!-- <div>如果设置产品，产品优先级高于通用设置</div> -->
          <el-table size="small" :data="form.tableData" border>
            <el-table-column label="图片" width="60">
              <template slot-scope="scope">
                <div class="product-info">
                  <div class="pic"><img width="30px" height="30px" v-img-url="scope.row.image" /></div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="商品"></el-table-column>



   

        <el-table-column label="直推类型" >
              <template slot-scope="scope">
                <el-radio-group  v-model="scope.row.ztype">
                  <el-radio :label="0">固定</el-radio>
                  <el-radio :label="1">比例</el-radio>
                </el-radio-group>
              </template>
            </el-table-column>


            <el-table-column label="直推奖励" >
              <template slot-scope="scope">
                <el-input v-model="scope.row.zprice" type="number" ></el-input>
              </template>
            </el-table-column>



            <el-table-column label="间推类型" >
              <template slot-scope="scope">
                <el-radio-group  v-model="scope.row.jtype">
                  <el-radio :label="0">固定</el-radio>
                  <el-radio :label="1">比例</el-radio>
                </el-radio-group>
              </template>
            </el-table-column>


            <el-table-column label="间推奖励" >
              <template slot-scope="scope">
                <el-input v-model="scope.row.jprice" type="number" ></el-input>
              </template>
            </el-table-column>



            <el-table-column label="次推类型" >
              <template slot-scope="scope">
                <el-radio-group  v-model="scope.row.ctype">
                  <el-radio :label="0">固定</el-radio>
                  <el-radio :label="1">比例</el-radio>
                </el-radio-group>
              </template>
            </el-table-column>


            <el-table-column label="次推奖励" >
              <template slot-scope="scope">
                <el-input v-model="scope.row.cprice" type="number" ></el-input>
              </template>
            </el-table-column>





            <el-table-column label="排序" width="100">
              <template slot-scope="scope">
                <el-input v-model="scope.row.sort" type="number"></el-input>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="deleteClick(scope.row)" type="text" size="small" >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form-item>

    </el-form>

    
    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" type="primary" @click="onSubmit" :disabled="loading">保存</el-button>
    </div>
    <Product :isproduct="isproduct" :excludeIds="product_arr" @closeDialog="closeProductDialogFunc($event)">产品列表弹出层</Product>
    <!--商品图片组件-->
    <!-- <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload> -->

  </div>
</template>
<script>
import HproductApi from '@/api/hproduct.js';
import Upload from '@/components/file/Upload';
import draggable from 'vuedraggable';
import Product from '@/components/product/Hproduct';
export default {
  components: {
    Upload,
    draggable,
    Product
  },
  data() {
    return {
      form: {
        status: false,
        tableData:[]

      },
      setting: [],
      loading: false,
      isProductUpload:false,
      type:[],
      isproduct:false,
      product_arr:[]
    };
  },
  created() {
    /*获取列表*/
    this.getSetting();
  },
  methods: {
      /*关闭弹窗*/
      closeProductDialogFunc(e) {
      this.isproduct = e.openDialog;
      if (e.type == 'success') {
        if (this.product_arr.indexOf(e.params.hproduct_id) > -1) {
          this.$message({
            message: '你已选中该产品',
            type: 'error'
          });
          return false;
        }
        let param = {};
        param.hproduct_id = e.params.hproduct_id;
        param.name = e.params.name;
        param.image = e.params.image;
        param.sort = 1;
        param.ztype = 1;
        param.zprice = 0;

        param.jtype = 1;
        param.jprice = 0;

        param.ctype = 1;
        param.cprice = 0;

        this.form.tableData.push(param);
        this.product_arr.push(e.params.hproduct_id);
      }
    },
    /*添加商品*/
    addClick() {
      this.isproduct = true;
    },
    /*删除商品*/
    deleteClick(e) {
      let index = this.product_arr.indexOf(e.hproduct_id);
      this.product_arr.splice(index, 1);
      this.form.tableData.splice(index, 1);
    },
    roundToDecimalPlace(number, decimalPlaces) {
        const factor = Math.pow(10, decimalPlaces);
        return Math.round(number * factor) / factor;
      },
      getPrice(price){
        console.log("price",this.roundToDecimalPlace(price,2))
        return this.roundToDecimalPlace(price,2)
      },
    delType(index){
        this.type.splice(index,1)
    },
      addType(){
        this.type.push({
          code: this.randomString(8, this.randomString(6, 0)), // 编号
          sort: 50, // 排序
          name: "", // 名称
          price: 0, // 单价
          unit: "", // 单位
          price_method: "", // 计价方式
          min_length: -1, // 最小长度 (-1 表示不限制)
          max_length: -1, // 最大长度 (-1 表示不限制)
          min_width: -1, // 最小宽度 (-1 表示不限制)
          max_width: -1, // 最大宽度 (-1 表示不限制)
          formula: "", // 计价公式
          size: "", // 产品尺寸
          supply_id: "", // 供应商ID
          capacity: 0, // 产能
        });


      },
    /*获取设置*/
    getSetting() {
      let self = this;
      let Params = {};
      HproductApi.getSetting(Params, true)
        .then(data => {
          self.loading = false;
          console.log(data)
          if(data.data.vars.values!='[]'){
            self.form = data.data.vars.values;
          }

          if( !self.form.tableData){
            self.form.tableData = [];
          }
      
          
        })
        .catch(error => {});

        // HproductApi.subcategory(Params, true)
        // .then(data => {
        //   self.loading = false;
        //   self.type = data.list.data;
          
        // })
        // .catch(error => {});
    },
    /*点击保存*/
    onSubmit() {
      let self = this;
      let params = self.form;
      self.loading = true;
      HproductApi.saveSetting(params, true)
        .then(data => {
          self.loading = false;
          if (data.code == 1) {
            self.$message({
              message: '恭喜你，保存成功',
              type: 'success'
            });
            self.getSetting();
          } else {
            self.loading = false;
          }
        })
        .catch(error => {
          self.loading = false;
        });

        for(var i=0;i<self.type.length;i++){
          HproductApi.subcategory_add(self.type[i], true)
          .then(data => {
            self.loading = false;
            self.type = data.list.data;
            
          })
        .catch(error => {});
        }


    },

  }
};
</script>

<style>
.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/hproduct/setting/getSetting.vue